export const httpRedirect = path => {
  window.location.href = path;
};
